import React from "react";
import { Languages } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../lib/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export function LanguageSwitcher({ dark = false }) {
  const { lang, setLang, t } = useLang();
  return (
    <Select
      value={lang}
      onValueChange={(v) => {
        setLang(v);
        toast.success(t("msg.lang_switched"));
      }}
    >
      <SelectTrigger
        data-testid="language-switcher-select"
        className={`w-[130px] h-9 ${dark ? "bg-slate-800 text-slate-100 border-slate-700" : "bg-white"}`}
      >
        <Languages className="h-4 w-4 mr-1 opacity-70" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-white">
        <SelectItem value="en" data-testid="lang-option-en">English</SelectItem>
        <SelectItem value="tet" data-testid="lang-option-tet">Tetum</SelectItem>
      </SelectContent>
    </Select>
  );
}
